export default __webpack_public_path__ + "static/tokens@2x-e37ce29ed083b509c7f8c1d15af855a6.png";